import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import { uploader } from '@/mixins/aws/uploader/s3';
import uploadProgress from '@/mixins/aws/uploader';
import path from 'path';
import linkPage from '@editor/droplets/_bubble-options/components/link-page';
import tooltip from '@/mixins/components/tooltip';
import linkDynamic from '@editor/droplets/_bubble-options/components/link-dynamic';

export default Vue.component('edit-imageGeneral', {
  template: require('./template.html'),
  mixins: [guid, uploader],
  components: {
    linkPage,
    uploadProgress,
    tooltip,
    linkDynamic,
  },
  computed: {
    ...mapGetters(['viewport', 'currentPage', 'currentSite']),
    enabledTypes() {
      const { type, addedTypes = [] } = this.currentSite;
      const allTypes = ['Choose...', type].concat(addedTypes);
      return _.uniq(allTypes).filter(type => type !== 'general');
    },
    fileName() {
      return path.basename(this.droplet.src);
    },
  },
  data() {
    return {
      tempPath: '',
      bucketPath: `_droplet-assets/imageGeneral/${this.droplet._id}/`,
      prefix: 'drz_image_general_',
      display: {
        altText: '',
        hasLink: false,
      },
    };
  },
  name: 'edit-imageGeneral',
  props: [
    'droplet',
    'show-edit-bubble',
    'active-site-type',
    'dynamic-item',
    'dynamic-data',
  ],
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.display.altText = this.droplet.altText || '';
      this.display.hasLink = this.droplet.hasLink;
      this.display.latestDynamic = this.droplet.latestDynamic;
      this.display.siteType = this.droplet.siteType || this.enabledTypes[0];
    },
    openUpload() {
      this.$refs.uploadFile.click();
    },
    async updateImg(e) {
      this.$validator.validateAll().then(async (result) => {
        // run only if file types and dimensions are correct
        if (result) {
          const evt = e;
          let newFile = [...evt.target.files];
          if (newFile.length > 0) {
            newFile = newFile[0];
            // clean up the file name for s3
            let fileName = path.basename(newFile.name);
            fileName = `${this.prefix}${_.trim(fileName)}`;
            fileName = _.replace(fileName, /\s+/g, '_');
            try {
              // send off to our s3 upload mixin
              const filePath = `/${this.bucketPath}${fileName}`;
              await this.uploadFile({
                file: `${this._sitePath}${filePath}`,
                body: newFile,
              });
              if (!this.droplet.uploadTouched) {
                this.$store.dispatch('setDropletVal', {
                  drp: this.droplet,
                  key: 'uploadTouched',
                  val: true,
                });
                this.$store.dispatch('changeDropletCss', {
                  drp: this.droplet,
                  val: '100%',
                  property: 'width',
                  selector: 'img',
                  viewport: 'desktop',
                });
                this.$emit('css-generator');
              }
              this.setImgSrc(filePath);
            } catch (err) {
              if (!err.message.match(/aborted/gi)) {
                this.$log.error(err);
                await this._reportError({
                  error: err,
                  fn: 'uploadImg - imageGeneral',
                });
              }
            }
          }
          // reset value to null so we can get the "change" event to run
          // in any case. Even when the user selects the same file
          evt.target.value = null;
        }
      });
    },
    setImgSrc(src) {
      const payload = {};
      payload.drp = this.droplet;
      payload.src = src;
      this.$store.dispatch('setImgGeneralSrc', payload);
      this.setInitialValues();
    },
    updateHasLink() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: 'hasLink',
        val: this.display.hasLink,
      });
    },
    setAltText() {
      const val = this._getInputVal(this.display.altText);
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: 'altText',
        val,
      });
    },
    formatErrors(ers) {
      return ers.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/image-general/components/_edit-options/index.js